import {EmailSendResponse, EmailContact} from "../api/dtos/dtos";
import {Modal} from "antd";
import locales from "../locales";
import * as React from "react";
import EmailContactTag from "./EmailContactTag";
import Label from "./Label";

interface Props {
  title: string;
  response: EmailSendResponse;
  onSuccess: () => void;
}


export const showEmailSendResultModal = (props: Props) => {
  const {successfulSendouts, failedSendouts} = props.response;

  const content = (
    <>
      {successfulSendouts.length > 0 && renderSendouts(locales.email_send_result_success, successfulSendouts)}
      {failedSendouts.length > 0 && renderSendouts(locales.email_send_result_failure, failedSendouts)}
    </>
  );

  if (successfulSendouts.length > 0 && failedSendouts.length === 0) {
    Modal.success({
      onOk: () => props.onSuccess(),
      okText: locales.ok,
      title: props.title,
      content,
    });
  } else if (successfulSendouts.length > 0 && failedSendouts.length > 0) {
    Modal.warn({
      okText: locales.ok,
      title: props.title,
      content,
    });
  } else {
    Modal.error({
      okText: locales.ok,
      title: props.title,
      content,
    });
  }
};

const renderSendouts = (label: string, contacts: EmailContact[]): React.ReactNode => {
  if (contacts.length === 0) {
    return null;
  }

  return (
    <>
      <Label value={label} style={{margin: 0}}/>

      {contacts.map((c) => {
        return (
          <div key={c.id} style={{marginTop: 4, marginBottom: 4}}>
            <EmailContactTag key={c.id} contact={c} />
          </div>
        );
      })}
    </>
  );
}


// WEBPACK FOOTER //
// ./src/common/EmailSendResultModal.tsx